// Texto de la carta. Conserva el formato con **negritas** y *cursivas*.
export const letter = {
    "recipient":  "Ali bonita",
    "title":  "Para mi princesa hermosa ❤️",
    "salutation":  "Mi Ali amada:",
    "blocks":  [
                   {
                       "text":  "He pensado muchas veces en cómo empezar esto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pensé en comenzar diciéndote que eres hermosa.\nPensé en decirte que me encantas.\nPensé en decirte que me fascinas.\nQue me vuelves loco.\nQue me haces sonreír.\nQue amo verte.\nQue amo escucharte.\nQue amo cada pequeño detalle que forma parte de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero mientras más lo pensaba, más me daba cuenta de que todas esas palabras tienen el mismo problema:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**se quedan cortas.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque decirte simplemente “me gustas” ya no alcanza.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me gustas tanto que hasta la propia frase *“me gustas”* se queda demasiado pequeña para explicar todo lo que provocas en mí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Así que tal vez la única manera de hacerlo es empezar desde el principio.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Desde ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Me encantas tú"
                   },
                   {
                       "text":  "Me encanta tu carita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Dios, cómo me encanta tu carita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Podría verla durante horas y probablemente seguiría encontrando pequeños detalles nuevos de los cuales enamorarme.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantan tus ojitos, porque tienen algo que no sé explicar completamente. Tienen un brillo que me encanta, que me transmite muchísimo y que muchas veces consigue hacerme sonreír con solamente mirarlos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu sonrisa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero muchísimo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu sonrisa me fascina porque tiene ese extraño poder de hacer que yo también quiera sonreír. Hay sonrisas bonitas y luego está la tuya, que para mí se siente diferente, porque cuando tú sonríes no solamente veo algo hermoso…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**veo a la persona que amo siendo feliz.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y creo que pocas cosas podrían gustarme más que eso.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me gustan tus labios, tus mejillas, tus pestañas, tus cejas, la manera en la que se ven tus ojos cuando te arreglas, cómo te queda tu delineado y cómo, aunque probablemente tú encuentres pequeños defectos cuando te ves frente al espejo, yo podría quedarme viéndote y pensar:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "*¿Cómo puede existir una niña tan hermosa?*",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu cabello.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y hay algo que llevo mucho tiempo imaginando.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sueño con que algún día tengamos esos momentos que para otras personas podrían parecer insignificantes, pero que para mí significarían muchísimo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tú arreglándote frente a un espejo, quizá maquillándote, preparándote para salir o simplemente haciendo cualquier cosa mientras me cuentas algo de tu día…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "y yo detrás de ti, cepillándote el cabello.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Peinándotelo con cuidado mientras hablamos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sin necesitar una fecha especial.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sin necesitar estar celebrando nada.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Simplemente tú y yo compartiendo uno de esos pequeños momentos que algún día quiero que sean parte de nuestra vida.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque cuando pienso en estar contigo no pienso únicamente en las grandes cosas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No pienso solamente en citas hermosas, regalos, flores o momentos que merezcan una fotografía.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "También pienso en la cotidianidad.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En poder preguntarte cómo estuvo tu día.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En escucharte contarme alguna cosa que hizo uno de tus niños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En acompañarte mientras haces tus manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En verte concentrada mientras creas algo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En tomar tu mano cuando caminemos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En molestarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En hacerte reír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En verte arreglarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "En decirte que estás hermosa aunque seguramente tú me respondas alguna cosa para llevarme la contraria ",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pienso en todas esas pequeñas cosas que, cuando son con la persona correcta, terminan convirtiéndose en las más importantes.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y yo quiero vivirlas contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Tus manos"
                   },
                   {
                       "text":  "Hay algo de ti que mencioné varias veces porque genuinamente me encanta:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**tus manos.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me parecen preciosas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Las he visto en fotografías y en algunos videos y siempre he pensado que se ven tan bonitas, tan delicadas, tan suaves…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y quiero tomarlas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero caminar contigo tomado de tu mano.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero entrelazar mis dedos con los tuyos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero besarlas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero que algún día pueda tomar una de tus manos, arrodillarme frente a ti y besarla como si fueras una princesita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero hay una razón todavía más bonita por la que amo tus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque he visto lo que eres capaz de hacer con ellas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tú haces arte, Ali.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y no te lo digo por decir.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "He visto tus piñatas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "He visto tus manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "He visto cosas que comienzan siendo prácticamente nada: materiales separados, pedazos de cosas que por sí solos probablemente no significan mucho…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "y entonces llegas tú.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Los tomas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Los cortas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Los acomodas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Los unes.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Les das forma.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y terminas creando algo precioso.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Haces arte prácticamente de la nada.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Creas desde cero.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y creo que eso dice muchísimo de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque no solamente haces cosas bonitas con tus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Les pones algo tuyo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu paciencia.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu creatividad.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu esfuerzo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu tiempo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu cariño.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu corazón.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y quizá por eso todo lo que haces termina teniendo algo tan especial.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque lleva una parte de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Amo a la maeta que eres"
                   },
                   {
                       "text":  "Hay una versión de ti que me enamora muchísimo y que quizá no pueda ver todos los días directamente, pero que admiro demasiado:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**la maeta Ali.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu paciencia con tus niños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta cuánto los quieres.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta ver cómo te esfuerzas para prepararles cosas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo haces materiales.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo buscas maneras de enseñarles.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo te preocupas por ellos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo celebras sus avances.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo dejas una parte de ti en tu salón y en cada niño que pasa por tu vida.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y creo que ahí se ve una de las cosas más hermosas de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu corazón.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque para ti ser maestra no parece simplemente una profesión.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tú realmente dejas el corazón ahí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y eso me fascina.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me fascina verte esforzarte al máximo por lo que quieres.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me fascina cómo puedes estar cansada y aun así seguir intentando que algo quede bonito.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo puedes dedicar tiempo a hacer algo especial para tus niños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo te importa que las cosas salgan bien.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y sí, puedo decirte mil veces que eres preciosa físicamente…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "pero también quiero que sepas esto:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**me parece preciosa la persona que eres cuando nadie te está diciendo que seas así.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu manera de querer.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu forma de esforzarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu creatividad.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu paciencia.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu forma de cuidar.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "La pasión que tienes por tu profesión.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Todo eso también forma parte de la mujer de la que estoy enamorado.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Y sí… me encantas físicamente"
                   },
                   {
                       "text":  "Muchísimo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sería imposible escribir todo esto y fingir que no.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me fascinas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu cuerpo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu cintura.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta tu abdomen.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantan tus piernas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantan tus clavículas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantan tus mejillas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantan tus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta cada lunar, cada pequeña marca y cada detalle que forma parte de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Incluso esos detallitos de tu cuerpo que probablemente tú jamás pensarías que alguien observa, yo los veo y me parecen preciosos porque son tuyos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Para mí son como pequeños puntos colocados sobre una obra de arte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y esa obra eres tú.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta abrazarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encanta imaginar tenerte cerquita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Poder tomarte por la cintura.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Besarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sentir tus brazos alrededor de mí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y sí, también me encanta ese lado nuestro más travieso, más intenso y más privado que existe entre nosotros.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque me encantas cuando eres tierna.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantas cuando eres romántica.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantas cuando estás seria.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantas cuando estás siendo una loquita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantas cuando estás en modo maeta.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y también me fascinas en ese otro lado que solamente nosotros conocemos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me gustas completa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Toda tú.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Porque no existe una sola Ali que yo ame"
                   },
                   {
                       "text":  "No amo únicamente a la Ali que se arregla y se ve preciosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo a la Ali despeinada.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali cansada.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que está haciendo manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que está trabajando.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que se emociona.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que se enoja.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que dice cosas que me hacen reír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que se pone seria.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali sensible.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali cariñosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la Ali que tiene paciencia.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo tus ocurrencias.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo tu voz.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo cómo te expresas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo cómo escribes.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo escucharte contarme cosas aunque sean cosas pequeñas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo cuando me enseñas algo que hiciste.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo poder decirte que estoy orgulloso de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Amo descubrir pequeñas cosas nuevas sobre ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y amo que, después de todo este tiempo, todavía pueda mirarte y sentir que quiero seguir conociéndote.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque no quiero conocer solamente a la Ali de ahora.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero conocer todas tus versiones.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero conocer a la Ali de mañana.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la de dentro de un año.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la de dentro de cinco.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la que tendrá nuevos sueños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la que habrá cumplido algunos y estará persiguiendo otros.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero ver cómo cambias.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo creces.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cómo evolucionas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y quiero poder estar ahí mientras sucede.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Si nuestra historia fuera Harry Potter…"
                   },
                   {
                       "text":  "Creo que podría buscar entre todos los hechizos existentes y aun así no encontraría uno capaz de explicar lo que siento por ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque esto no se siente como *Amortentia*.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No necesito una poción que me obligue a sentir algo por ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Te amo siendo completamente consciente de quién eres.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Conociendo tus virtudes.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus defectos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus días bonitos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus días difíciles.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus enojos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus miedos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus sueños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus rarezas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Todo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y aun así —o quizá precisamente por todo eso— te elijo a ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si existiera un *Espejo de Oesed* para mí y me pusiera frente a él, creo que no necesitaría demasiado tiempo para descubrir cuál es uno de mis deseos más profundos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Probablemente te vería a ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero no simplemente parada a mi lado.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Vería una vida.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Vería nuestras manos juntas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Vería todas esas cosas pequeñas que sueño vivir contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Vería nuestras risas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras aventuras.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras estupideces.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras reconciliaciones después de alguna discusión.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros días buenos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros días malos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y nos vería eligiéndonos una y otra vez.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque si algo aprendí de ese mundo que tanto te gusta es que existen cosas que son mucho más poderosas que cualquier hechizo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y una de ellas siempre ha sido el amor.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Yo no quiero prometerte una historia donde jamás existan problemas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero algo mucho más real:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "quiero prometerte que mi intención es elegirte incluso cuando nuestra historia atraviese sus capítulos difíciles.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que si alguna vez sentimos que estamos perdidos en el Bosque Prohibido, quiero buscar contigo la salida.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que si aparecen dementores en nuestros días más oscuros, quiero recordar contigo todas las razones que tenemos para volver a encontrar la luz.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y que si alguna vez necesitamos un Patronus para recordarnos algo bonito…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "yo quiero poder pensar en nosotros.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Y si nuestra historia fuera Shrek…"
                   },
                   {
                       "text":  "Entonces creo que hay algo que entendería perfectamente.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "El amor verdadero no siempre se parece a los cuentos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No siempre llega perfecto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No siempre ocurre de la manera correcta.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A veces tiene errores.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A veces hay momentos feos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A veces toca atravesar cosas que jamás habríamos querido vivir.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero también puede haber algo verdadero debajo de todo eso.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Fiona no necesitaba convertirse en alguien diferente para merecer amor.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Al contrario.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "El amor verdadero fue poder mostrarse tal como era y descubrir que seguía siendo amada.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y eso quiero que sepas tú.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No necesito una versión perfecta de Ali.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero que seas otra persona.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero que cambies las cosas que te hacen tú para encajar en alguna idea de lo que debería ser una mujer perfecta.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque mi mujer perfecta tiene tus ojitos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu sonrisa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu carácter.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu manera de escribir.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu forma de hacer manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu amor por tus niños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus enojos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus ocurrencias.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu ternura.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus gustos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus rarezas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu forma de ser.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tiene tu nombre.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Para mí, princesa, **eres tú.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y si algún día terminamos viviendo en un pantano, solo espero que tenga buen internet ",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero si es contigo…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "hasta el pantano podría convertirse en un hogar.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Y sé que también amas a Merlina…"
                   },
                   {
                       "text":  "Así que quizá decirte que quiero una historia “por toda la eternidad” contigo sea peligrosamente apropiado ",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque contigo hasta lo oscuro puede sonar romántico.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Podría decirte que quiero amarte hasta que la muerte nos separe…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "pero siento que Merlina probablemente consideraría eso muy poco ambicioso.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Así que prefiero decirte:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "quiero amarte incluso cuando nuestros cabellos sean diferentes, nuestras manos tengan arruguitas y hayamos vivido tantas cosas juntos que necesitemos horas para contar todas nuestras historias.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir viendo tus ojos y reconocer en ellos a mi niña hermosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir tomando esas manos que hoy me parecen tan preciosas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir diciéndote que eres hermosa aunque hayan pasado años y años.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir molestándote.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Seguir haciéndote reír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Seguir escuchándote.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Seguir descubriéndote.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Seguir enamorándome de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Hasta que “para siempre” también nos quede corto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Eso sí me parece suficientemente macabro y romántico para que Merlina lo apruebe.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Porque yo no quiero solamente momentos contigo"
                   },
                   {
                       "text":  "Quiero recuerdos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero años.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero etapas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero historias que algún día podamos contar diciendo:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "“¿Te acuerdas cuando…?”",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero fotografías que dentro de muchos años veamos y nos hagan reír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero guardar pequeños recuerdos tuyos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero saber cómo cambian tus gustos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero celebrar tus logros.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero acompañarte cuando algo no salga como esperabas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero escucharte hablar de tu trabajo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero verte crear muchísimas cosas más con esas manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero conocer más lugares contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero citas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero noches hablando de cualquier estupidez.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero conversaciones profundas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero besos inesperados.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero abrazos largos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero tomarte de la mano.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero que haya momentos en los que no necesitemos decir absolutamente nada porque simplemente estar juntos sea suficiente.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero poder verte un día y pensar:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "*Dios… han pasado tantos años y todavía me encanta esta mujer.*",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque no quiero quererte solamente cuando todo sea emocionante.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero quererte también cuando la vida sea rutinaria.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cuando estemos cansados.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cuando tengamos responsabilidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cuando un día no haya ninguna aventura extraordinaria y nuestro gran plan sea simplemente estar juntos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque ahí también quiero encontrarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Quiero hacer las cosas bien"
                   },
                   {
                       "text":  "Y sé que amar a alguien no significa solamente escribir cosas bonitas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Las palabras son preciosas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero tienen que caminar acompañadas de acciones.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Por eso este escrito no pretende ser una promesa de perfección.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero venderte una historia donde yo jamás vuelva a equivocarme, porque sería mentirte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Lo que sí quiero es que mis acciones puedan demostrarte lo que mis palabras están intentando decirte aquí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que te amo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que te elijo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que quiero cuidarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que quiero respetarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que quiero aprender de mis errores.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que quiero construir algo bonito contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que quiero que puedas sentirte amada no solamente cuando leas algo romántico que escribí para ti, sino también en la forma en la que te trato cada día.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero que el tiempo pueda hablar por mí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y que algún día, cuando vuelvas a leer esto, puedas decir:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**“Sí lo hizo.”**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Mi niña hermosa…"
                   },
                   {
                       "text":  "Tú me gustas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Muchísimo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero ya te dije que esa frase se queda pequeña.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Así que voy a intentarlo otra vez.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me encantas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "También se queda corta.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me fascinas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Todavía no.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Te amo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y aunque esas dos palabras son mucho más grandes…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "siento que incluso ellas necesitan todo este escrito para explicar lo que quiero decir cuando las pronuncio.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque cuando te digo **“te amo”**, te estoy diciendo que amo tu carita.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus ojos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu sonrisa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu cabello.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus labios.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus mejillas.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu cuerpo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus pequeños detalles.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu voz.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu forma de escribir.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu creatividad.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu profesión.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu paciencia con tus niños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu corazón.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu esfuerzo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu manera de querer.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu ternura.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tu carácter.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus locuras.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus defectos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus sueños.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Tus diferentes versiones.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Todo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cuando te digo **“te amo”**, en realidad estoy intentando comprimir cientos de cosas en solamente dos palabras.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y quizá por eso te lo repito tanto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque ninguna vez parece suficiente.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  2,
                       "type":  "heading",
                       "text":  "Hay algo curioso sobre esta página…"
                   },
                   {
                       "text":  "Algún día esta dirección tendrá otro propósito.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Aquí habrá números.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Registros.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Movimientos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Transacciones.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Cosas completamente diferentes a una declaración de amor.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Probablemente alguien entre aquí en el futuro sin imaginar que, antes de todo eso, este pequeño lugar en internet tuvo otro propósito.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Tú.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y me gusta muchísimo pensar eso.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que antes de guardar transacciones, esta página guardó algo mucho más importante para mí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Una parte de mi corazón.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que su primera historia no fue un número.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No fue un movimiento.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No fue un registro.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Fue una declaración para la mujer que amo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Por eso quise regalártela.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quise que este fuera tu primer encuentro con este lugar.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que antes de convertirse en lo que será en el futuro, durante un momento fuera solamente nuestro.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Un pequeño rincón de internet hecho para recordarte algo:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**que existe alguien que está profundamente enamorado de ti.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y si algún día, mucho tiempo después, esta página cambia completamente y aquí ya no queda nada de lo que estás viendo ahora, quiero que recuerdes que alguna vez estuvo aquí.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que este fue el principio.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Que antes de cualquier otra cosa que existiera en esta dirección…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**estuviste tú.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "text":  "Ali…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Yo quiero seguir descubriendo cada detalle de ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir aprendiendo cómo amarte mejor.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir conociendo cada una de tus versiones.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero tomar esas manos que tanto me encantan y caminar contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero peinarte el cabello mientras me cuentas cualquier cosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero verte sonreír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir admirando las cosas que haces.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero seguir diciéndote que eres preciosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero estar orgulloso de la maeta que eres.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero besarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero abrazarte.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero reír contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero vivir aventuras contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero vivir días completamente normales contigo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero estar en tus momentos felices.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero acompañarte en los difíciles.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero crear recuerdos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero crear una historia.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y quiero que esa historia sea tan nuestra que no necesite parecerse a ninguna otra.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero el amor de Shrek y Fiona.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero una historia escrita en Hogwarts.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "No quiero un romance salido de la mente de Merlina.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Me gustan porque forman parte de las cosas que te gustan a ti y porque me permiten jugar con ellas para decirte cuánto te amo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero si pudiera elegir entre todas las historias de amor que existen…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**elegiría la nuestra.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Con nuestros chistes.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros momentos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras locuras.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros errores.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros recuerdos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestros besos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras palabras.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Nuestras maneras de querernos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque entre todos los mundos ficticios, todos los cuentos y todas las historias posibles…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "mi lugar favorito sigue siendo uno muy sencillo:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**a tu lado.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y entre todas las personas que existen en este enorme mundo, sigo queriendo a una.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la niña de los ojitos hermosos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la de la sonrisa que me hace sonreír.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la maeta que deja el corazón en lo que hace.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la artista que crea cosas preciosas con sus manos.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la niña de las manualidades.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A la mujer que me fascina.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A mi niña hermosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "A ti.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Aline.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Así que después de tantas palabras, tantos pensamientos, tantos sueños y tantas maneras diferentes de intentar explicarte algo que probablemente jamás terminaré de explicar por completo…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "solo queda una cosa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "La verdadera razón por la que hice todo esto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Mi niña hermosa ❤️",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si pudiera tener enfrente el Espejo de Oesed, sé qué deseo quisiera encontrar reflejado.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si tuviera que escoger a una princesa, escogería a mi Fiona.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y si Merlina me preguntara cuánto tiempo pretendo amarte, probablemente mi respuesta sería suficientemente exagerada, oscura y romántica para sacarle aunque sea una pequeñísima sonrisa.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque no quiero pedirte solamente un ratito.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Ni algunos meses.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Ni algunos años.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Yo quiero seguir eligiéndote mientras la vida nos permita hacerlo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y si existe algo después…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "pues también ahí :3",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Por eso, mi amor, entre absolutamente todas las cosas que podría pedirte, **lo que más deseo es pedirte lo siguiente:**",
                       "type":  "paragraph"
                   },
                   {
                       "level":  1,
                       "type":  "heading",
                       "text":  "¿Quieres ser mi novia por toda la eternidad? ❤️"
                   },
                   {
                       "text":  "No quiero que respondas esta pregunta porque todo lo que escribí sea bonito.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Quiero que la respondas cuando tu corazón esté preparado para hacerlo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Porque tu respuesta merece ser tuya.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sin presión.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Sin miedo.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y completamente sincera.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Yo ya sé cuál es la mía.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si me preguntaran a mí con quién quiero intentar escribir los siguientes capítulos de mi vida…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**contigo.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si me preguntaran de quién quiero seguir enamorándome…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**de ti.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Si me preguntaran qué mano quiero tomar mientras camino hacia todo lo que todavía no conozco…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**la tuya.**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y si me preguntaran cuánto tiempo quisiera amarte…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "creo que ya conoces mi respuesta.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Por toda la eternidad. ❤️**",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "",
                       "type":  "divider"
                   },
                   {
                       "level":  3,
                       "type":  "heading",
                       "text":  "P. D."
                   },
                   {
                       "text":  "Y hay algo que me hace sonreír muchísimo:",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Algún día quizá alguien entre a esta dirección únicamente para consultar una transacción y jamás tendrá idea de que, antes de números, registros y movimientos, aquí hubo un niño completamente enamorado escribiéndole una cantidad exagerada de palabras a su niña hermosa para hacerle una sola pregunta ",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Pero nosotros sí lo vamos a saber.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "Y por eso, sin importar en qué se convierta esta página después…",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "para mí siempre va a guardar un secreto.",
                       "type":  "paragraph"
                   },
                   {
                       "text":  "**Que antes de guardar cualquier otra cosa, aquí guardé un pedacito de todo lo que siento por ti. ❤️**",
                       "type":  "paragraph"
                   }
               ]
};
